import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import '../Cta/Cta.css';

const CtaBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Phone numbers
  const phoneNumber = '+91 96549 45825';
  const whatsappNumber = '+919654945825';
  const whatsappMessage = 'Hello! I need assistance.';

  // WhatsApp URL
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
  
  // Direct call URL
  const callUrl = `tel:${phoneNumber}`;

  // Check if mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsVisible(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="cta-bar-container">
      <div className="cta-bar">
        {/* WhatsApp Link */}
        <a 
          href={whatsappUrl}
          className="cta-button whatsapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp className="whatsapp-icon" />
          <span>WhatsApp</span>
        </a>

        {/* Direct Call Link */}
        <a 
          href={callUrl}
          className="cta-button call"
          aria-label="Call us directly"
        >
          <FaPhoneAlt className="call-icon" />
          <span>Call Now</span>
        </a>
      </div>
    </div>
  );
};

export default CtaBar;